export type BillingInterval = 'monthly' | 'yearly';

export const stripeConfig = {
  publishableKey: 'pk_live_51Ts2WiCvnCa3r1xG74D4FLCRpVrlj3yV6BHSVQggHzH8QN6IaMoTIixxRVv5QGQ1l34w6CJOl3x1fmKCTSWhkZvE00nAuSoLIh',
  paymentLinks: {
    'Level Map Pro Indicator': {
      monthly: 'https://buy.stripe.com/00w8wOgVc35K4e57j54wM00',
      yearly: 'https://buy.stripe.com/cNi8wO5cu5dS3a15aX4wM03',
    },
    'Smart Trader Panel': 'https://buy.stripe.com/5kQ28qcEWbCgdOF5aX4wM02',
    'Trader Assistant Pro': 'https://buy.stripe.com/9B68wO9sK6hW3a146T4wM01',
    'StockLevelMap': {
      yearly: 'https://buy.stripe.com/6oUdR80WedKo11TeLx4wM05',
      monthly: 'https://buy.stripe.com/9B6eVcfR80XC7qhgTF4wM04',
    },
  } as Record<string, string | Record<BillingInterval, string>>,
};
